// extracted by mini-css-extract-plugin
module.exports = {"linkWrap":"styles-module--linkWrap--3O6OA"};